import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { tooltipProps, tooltipEmits } from './tooltip';
import { UPDATE_MODEL_VALUE } from '../../constants';
import { type TooltipBinding } from '../../directives';


export default /*#__PURE__*/_defineComponent({
  __name: 'tooltip',
  props: tooltipProps,
  emits: tooltipEmits,
  setup(__props, { emit: emits }) {

const props = __props




const wrapperRef = ref<HTMLElement>();

const modifiers = computed<string[]>(() => {
    return [
        'ui-tooltip__panel',
        props.arrow && '--arrow',
        props.color && `--color-${props.color}`,
    ];
});

const binding = computed<TooltipBinding>(() => {
    return {
        toggle: props.disabled ? false : props.modelValue,
        hover: props.hover,
        focus: props.focus,
        offset: props.offset,
        placement: props.placement,
        ref: wrapperRef.value?.firstElementChild as HTMLElement | undefined,
        width: props.width,
        maxWidth: props.maxWidth,
        onChange: (visible: boolean) => emits(UPDATE_MODEL_VALUE, visible),
    };
});

return { __sfc: true,props, emits, wrapperRef, modifiers, binding }
}

})